// Report-param grammar for the info-view table, ported from the items-list base the block used to
// extend (importReportParams / updateReportParams).
//
// One param carries its state:
//   s   the order the researcher sorted the items list by
//
// The alphabet is the one every other block writes `s` in, so a report saved against a question
// block reads back the same way against its info view.

import {
  DEFAULT_SORT_ORDER,
  decodeSortParam,
  encodeSortParam
} from '@aytm/app/stats/page/question-views/components/lib/sort-param'

export { DEFAULT_SORT_ORDER }

export const resolveSortOrder = (section, defaultSortOrder = DEFAULT_SORT_ORDER) =>
  decodeSortParam(section, { defaultSortOrder })

export const calcSortParamsSection = (sortOrder, defaultSortOrder = DEFAULT_SORT_ORDER) => ({
  s: encodeSortParam(sortOrder, { defaultSortOrder })
})
